// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-danger[data-v-e8f89f4c] \n{\n  font-size: larger;\n}\n", ""]);
// Exports
module.exports = exports;
